import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  spaceXLarge,
  fontWeights,
  fontFamilies,
  breakpoints,
  halfWidth,
  spaceMin,
}: Theme) => ({
  root: {
    padding: `${spaceXLarge} 0`,
  },
  contentStyles: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',
  },
  stepsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: spaceMin,
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      '& > *': {
        flexBasis: `calc(${halfWidth})`,
      },
    },
  },
  list: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem',
    padding: 0,
    margin: '0 0 2.5rem',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    margin: 0,
  },
  listItemTitle: {
    margin: '0 0 1rem',
    paddingBottom: '0.5rem',
    borderBottom: `2px solid ${palette.primary.dark}`,
    color: palette.primary.main,
    fontSize: '1.75rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.1,
    letterSpacing: -0.56,
  },
  listItemContent: {
    margin: 0,
    fontSize: '1.25rem',
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.regular,
    lineHeight: 1.3,
  },
  ctaWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3.5rem 2rem',
    border: `2px solid ${palette.primary.dark}`,
    gap: '2.5rem',
  },
  cta: {
    margin: 0,
    color: palette.primary.dark,
    fontSize: '2.375rem',
    lineHeight: 1.1,
    fontWeight: fontWeights.regular,
    textAlign: 'center',
  },
  img: {
    width: '100%',
    height: 'auto',
    [breakpoints.up('md')]: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  link: {
    color: palette.primary.dark,
    '&:hover': {
      backgroundColor: palette.primary.contrastText,
    },
  },
  disclaimer: {
    margin: 0,
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.regular,
    fontSize: '1.125rem',
  },
  imageWrapper: {
    position: 'relative',
    overflow: 'hidden',
  },
}));
